import React from 'react';
import { Helmet } from 'react-helmet';
import InfoBox from '../../components/info-box/info-box.jsx';

import './about-wrapper.css';

const AboutWrapper = ({data}) => {

  return (
    <div className="about-wrapper">
        <Helmet>
            <title>About Us - Serene Manor Adult Family Home</title>
            <meta name="description" content={data?.aboutUs?.metaDescription || data?.aboutUs?.text?.substring(0, 155)} />
            <link rel="canonical" href="https://www.theserenemanorafh.com/about-us" />
            <meta property="og:title" content="About Us - Serene Manor Adult Family Home" />
            <meta property="og:type" content="website" />
            <meta property="og:url" content="https://www.theserenemanorafh.com/about-us" />
            <meta property="og:image" content={data?.landingImage?.image} />
            <meta property="og:description" content={data?.aboutUs?.metaDescription || data?.aboutUs?.text?.substring(0, 155)} />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content="About Us - Serene Manor Adult Family Home" />
            <meta name="twitter:description" content={data?.aboutUs?.metaDescription || data?.aboutUs?.text?.substring(0, 155)} />
            <meta name="twitter:image" content={data?.landingImage?.image} />
            <script type="application/ld+json">
              {JSON.stringify({
                "@context": "https://schema.org",
                "@type": "AboutPage",
                "mainEntity": {
                  "@type": "LocalBusiness",
                  "name": "Serene Manor Adult Family Home",
                  "image": "https://www.theserenemanorafh.com/assets/images/serene_manor_logo_mini.png",
                  "telephone": data?.contactDetails?.phone,
                  "address": {
                    "@type": "PostalAddress",
                    "streetAddress": data?.contactDetails?.address
                  }
                }
              })}
            </script>
        </Helmet>
        <div className="row about-us-wrapper">
          <InfoBox title={data.aboutUs.title} text={data.aboutUs.text}/>
        </div>
        <footer className='footer full-width margin-top-5'>
          <div className="container center">
            <p>&copy; {data.footer.text}</p>
          </div>
        </footer>
    </div>
  );

}

export default AboutWrapper;
